import { B as BaseComponent, _ as __decorate, a as __metadata } from '../index-C155IGn1.js';
import { css, html } from 'lit';
import { when } from 'lit/directives/when.js';
import { queryAssignedElements, property, customElement } from 'lit/decorators.js';
import 'lit/directive.js';

var styles = css`*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: hsla(0, 0%, 0%, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

p {
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: var(--bsi-spacing-s);
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: var(--bsi-spacing-l);
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: var(--bsi-spacing-s);
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: var(--bsi-font-weight-strong);
}

dd {
  margin-bottom: var(--bsi-spacing-xxs);
  margin-left: 0;
}

blockquote {
  margin: 0 0 var(--bsi-spacing-s);
}

sub,
sup {
  position: relative;
  font-size: var(--bsi-font-size-1);
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--bsi-color-link);
  text-decoration: underline;
  text-decoration-skip-ink: auto;
  text-underline-offset: 2px;
}
a:hover {
  color: var(--bsi-color-link-hover);
  cursor: pointer;
}

pre,
code,
kbd,
samp {
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
  overflow: auto;
}
pre code {
  word-break: normal;
}

a > code {
  color: inherit;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: hsl(210, 17%, 44%);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

:host {
  --bsi-pagination-padding-x: 0.75rem;
  --bsi-pagination-padding-y: 0.375rem;
  --bsi-pagination-font-size: 1rem;
  --bsi-pagination-color: var(--bsi-color-link);
  --bsi-pagination-bg: hsl(0, 0%, 100%);
  --bsi-pagination-border-width: 0;
  --bsi-pagination-border-color: hsl(0, 0%, 83%);
  --bsi-pagination-border-radius: 4px;
  --bsi-pagination-hover-color: var(--bsi-color-link-hover);
  --bsi-pagination-hover-bg: hsl(0, 0%, 90%);
  --bsi-pagination-hover-border-color: hsl(0, 0%, 83%);
  --bsi-pagination-focus-color: var(--bsi-color-link-hover);
  --bsi-pagination-focus-bg: hsl(0, 0%, 90%);
  --bsi-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(0, 102, 204, 0.25);
  --bsi-pagination-active-color: hsl(0, 0%, 100%);
  --bsi-pagination-active-bg: hsl(210, 100%, 40%);
  --bsi-pagination-active-border-color: hsl(210, 100%, 40%);
  --bsi-pagination-disabled-color: hsl(0, 0%, 32%);
  --bsi-pagination-disabled-bg: hsl(0, 0%, 100%);
  --bsi-pagination-disabled-border-color: hsl(0, 0%, 83%);
  --bsi-pagination-padding-x: var(--bsi-spacing-s);
  --bsi-pagination-padding-y: var(--bsi-spacing-xxs);
  --bsi-pagination-link-color: var(--bsi-color-link);
  --bsi-pagination-background: transparent;
  --bsi-pagination-border-width: 2px;
  --bsi-pagination-border-color: transparent;
  --bsi-pagination-border-radius: 4px;
  --bsi-pagination-item-size: 3rem;
  --bsi-pagination-font-size: var(--bsi-label-font-size);
  display: flex;
  padding-left: 0;
  list-style: none;
  width: 100%;
}

:host a {
  text-decoration: unset !important;
}

.pagination-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  margin-block: var(--bsi-spacing-xxs);
}

.pagination-wrapper.pagination-total {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.pagination {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  gap: 8px;
}

.pagination-wrapper.pagination-total .pagination {
  margin-bottom: var(--bsi-spacing-xxs);
}

.pagination-next-wrapper,
.pagination-prev-wrapper {
  display: flex;
  align-items: center;
}

.page-item {
  display: flex;
  padding-left: 0;
  list-style: none;
  height: fit-content;
}
.page-item .page-link {
  position: relative;
  display: flex;
  min-width: var(--bsi-pagination-item-size);
  align-items: center;
  justify-content: center;
  padding: var(--bsi-pagination-padding-y) var(--bsi-pagination-padding-x);
  border: var(--bsi-pagination-border-width) solid var(--bsi-pagination-border-color);
  border-radius: var(--bsi-pagination-border-radius);
  color: var(--bsi-pagination-link-color) !important;
  font-weight: var(--bsi-font-weight-solid);
  gap: 0.25rem;
  font-size: var(--bsi-pagination-font-size, 1rem);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-item .page-link {
    transition: none;
  }
}
.page-item a.page-link:hover {
  --bsi-pagination-link-color: var(--bsi-color-link-hover);
  text-decoration: underline !important;
}
.page-item a.page-link:focus-visible {
  border-color: hsl(0, 0%, 0%) !important;
  box-shadow: 0 0 0 2px var(--bsi-color-border-inverse), 0 0 0 5px var(--bsi-color-outline-focus) !important;
  outline: 3px solid transparent !important;
  outline-offset: 3px !important;
}
.page-item span.page-link {
  pointer-events: none;
}

::slotted([slot=page-changer]),
::slotted([slot=jump-to-page]),
::slotted([slot=total]) {
  display: inline-flex;
  align-items: center;
}

::slotted([slot=total]) {
  margin-bottom: var(--bsi-spacing-s) !important;
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-label-font-size) !important;
  font-weight: var(--bsi-font-weight-solid) !important;
  text-align: center;
}

::slotted([slot=prev]),
::slotted([slot=next]) {
  position: relative;
  display: flex;
  min-width: var(--bsi-pagination-item-size);
  height: var(--bsi-pagination-item-size);
  align-items: center;
  justify-content: center;
  padding: var(--bsi-pagination-padding-y) var(--bsi-pagination-padding-x);
  border: var(--bsi-pagination-border-width) solid var(--bsi-pagination-border-color);
  border-radius: var(--bsi-pagination-border-radius);
  color: var(--bsi-pagination-link-color) !important;
  font-weight: var(--bsi-font-weight-solid);
  font-size: var(--bsi-pagination-font-size, 1rem);
}

:host([align=center]) {
  justify-content: center;
  margin: auto;
}

:host([align=end]) {
  width: 100%;
  justify-content: flex-end;
}

:where(:host([responsive])) .pagination-wrapper {
  flex-direction: column;
  align-items: stretch;
}
@media (min-width: 576px) {
  :where(:host([responsive])) .pagination-wrapper {
    flex-direction: row;
    align-items: center;
  }
}

:where(:host([responsive])) .pagination-wrapper .pagination {
  width: 100%;
}
@media (min-width: 576px) {
  :where(:host([responsive])) .pagination-wrapper .pagination {
    width: auto;
    justify-content: center;
  }
}

.page-link[aria-current] {
  --bsi-pagination-border-color: var(--bsi-color-border-primary-active);
  --bsi-pagination-link-color: var(--bsi-color-link-active);
  pointer-events: none;
}

.page-item.more {
  display: none;
}
@media (min-width: 576px) {
  .page-item.more {
    display: flex;
  }
}`;

/* eslint-disable lit-a11y/click-events-have-key-events */
let ItPagination = class ItPagination extends BaseComponent {
    constructor() {
        super(...arguments);
        this.value = '1';
        this.total = undefined;
        this.align = 'center';
        this.disableResponsive = false;
        this.simpleMode = false;
        this.visiblePages = 5;
        this.itAriaLabel = '';
    }
    updated(changedProperties) {
        super.updated?.(changedProperties);
        if (changedProperties.has('value') ||
            changedProperties.has('total') ||
            changedProperties.has('simpleMode') ||
            changedProperties.has('visiblePages')) {
            this.updatePaginationItems();
            this.updatePaginationItemsClasses();
            this.updateNavigationButtons();
        }
        if (changedProperties.has('disableResponsive') && changedProperties.get('disableResponsive') !== undefined) {
            this.updatePaginationItemsClasses();
        }
    }
    emitPageChange(newPage) {
        const currentPage = parseInt(this.value, 10);
        const totalPages = this.total ? parseInt(this.total, 10) : this.paginationItems.length;
        if (newPage < 1)
            return;
        if (totalPages > 0 && newPage > totalPages)
            return;
        if (newPage === currentPage)
            return;
        const event = new CustomEvent('it-pagination-change', {
            detail: { page: newPage },
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
        this.value = newPage.toString();
    }
    handleItemClick(e) {
        e.stopPropagation(); // Fermiamo l'evento interno, non serve che esca
        const page = parseInt(e.detail.page, 10);
        if (!Number.isNaN(page)) {
            this.emitPageChange(page);
        }
    }
    handlePrevClick(e) {
        e.preventDefault();
        const currentPage = parseInt(this.value, 10);
        if (currentPage > 1) {
            this.emitPageChange(currentPage - 1);
        }
    }
    handleNextClick(e) {
        e.preventDefault();
        const currentPage = parseInt(this.value, 10);
        const totalPages = this.total ? parseInt(this.total, 10) : this.paginationItems.length;
        // Se non c'è 'total', assumiamo che ci siano altre pagine finché ci sono items
        if (!totalPages || currentPage < totalPages) {
            this.emitPageChange(currentPage + 1);
        }
    }
    updatePaginationItemsClasses() {
        if (this.paginationItems.length) {
            const pages = this.calculatePages();
            this.paginationItems.forEach((item) => {
                const isCurrentPage = item.page === this.value;
                const itemPageNum = parseInt(item.page, 10);
                const isInVisiblePages = pages.includes(itemPageNum);
                // Remove all classes first
                item.classList.remove('d-none', 'd-sm-flex');
                // In simple mode, hide all pagination items (we render current/total instead)
                if (this.simpleMode) {
                    item.classList.add('d-none');
                    return;
                }
                // In more mode, hide items not in visible pages
                if (!isInVisiblePages) {
                    item.classList.add('d-none');
                    return;
                }
                // Apply responsive hiding for non-current pages (when NOT disabled)
                if (!this.disableResponsive && !isCurrentPage) {
                    item.classList.add('d-none', 'd-sm-flex');
                }
            });
        }
    }
    updatePaginationItems() {
        if (this.paginationItems.length) {
            this.paginationItems.forEach((item) => {
                const isCurrentPage = item.page === this.value;
                // eslint-disable-next-line no-param-reassign
                item.current = isCurrentPage;
            });
        }
    }
    updateNavigationButtons() {
        const currentPage = parseInt(this.value, 10);
        const totalPages = this.total ? parseInt(this.total, 10) : this.paginationItems.length;
        // Update prev button visual state
        if (this.prevElements.length) {
            this.prevElements.forEach((el) => {
                if (currentPage <= 1) {
                    el.setAttribute('aria-disabled', 'true');
                    el.classList.add('disabled');
                    // el.setAttribute('tabindex', '-1');
                }
                else {
                    el.removeAttribute('aria-disabled');
                    el.classList.remove('disabled');
                }
                el.classList.add('page-link');
            });
        }
        // Update next button visual state
        if (this.nextElements.length) {
            this.nextElements.forEach((el) => {
                if (totalPages && currentPage >= totalPages) {
                    el.setAttribute('aria-disabled', 'true');
                    el.classList.add('disabled');
                }
                else {
                    el.removeAttribute('aria-disabled');
                    el.classList.remove('disabled');
                }
                el.classList.add('page-link');
            });
        }
    }
    handleSlotChange() {
        this.updatePaginationItems();
        this.updatePaginationItemsClasses();
        this.updateNavigationButtons();
    }
    handlePrevSlotChange() {
        this.updateNavigationButtons();
    }
    handleNextSlotChange() {
        this.updateNavigationButtons();
    }
    handleTotalSlotChange() {
        // Update component and rerender when total slot changes
        this.requestUpdate();
    }
    /**
     * Calculate which pages to display based on simpleMode and visiblePages
     * Returns an array of page numbers to show
     */
    calculatePages() {
        const currentPage = parseInt(this.value, 10);
        const totalPages = this.total ? parseInt(this.total, 10) : this.paginationItems.length;
        if (this.simpleMode) {
            return [currentPage];
        }
        if (totalPages <= this.visiblePages) {
            // If total pages is less than visiblePages, show all
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        }
        // More mode: calculate which pages to show
        const halfVisiblePages = Math.floor(this.visiblePages / 2);
        let start = currentPage > halfVisiblePages ? currentPage - halfVisiblePages : 1;
        // Calculate the length based on visible pages
        const length = this.visiblePages;
        // Adjust start if we're near the end
        if (currentPage >= totalPages) {
            start -= halfVisiblePages;
        }
        else if (currentPage >= totalPages - halfVisiblePages) {
            start -= totalPages - (currentPage + 1);
        }
        // Make sure start is at least 1
        if (start < 1) {
            start = 1;
        }
        return Array.from({ length }, (_, i) => i + start).filter((page) => page <= totalPages);
    }
    render() {
        const navClasses = this.composeClass('pagination-wrapper', this.totalElements.length > 0 && 'pagination-total');
        const ulClasses = this.composeClass('pagination', this.disableResponsive && 'pagination-responsive');
        const currentPage = parseInt(this.value, 10);
        const totalPages = this.total ? parseInt(this.total, 10) : this.paginationItems.length;
        const pages = this.calculatePages();
        const showFirstPage = totalPages > this.visiblePages && pages[0] > 1;
        const showFirstEllipsis = totalPages > this.visiblePages && pages[0] > 2;
        const showLastPage = totalPages > this.visiblePages && pages[pages.length - 1] < totalPages;
        const showLastEllipsis = totalPages > this.visiblePages && pages[pages.length - 1] < totalPages - 1;
        return html `
      <nav class="${navClasses}" aria-label="${this.itAriaLabel}">
        <ul class="${ulClasses}" @it-item-click="${this.handleItemClick}" part="pagination-list">
          <li class="pagination-prev-wrapper page-item" @click="${this.handlePrevClick}">
            <slot name="prev" @slotchange="${this.handlePrevSlotChange}"></slot>
          </li>

          ${when(this.simpleMode, () => html `
              <li class="page-item visually-hidden">
                <a class="page-link" href="#" aria-current="page"> Pagina ${currentPage} di ${totalPages} </a>
              </li>
              <li class="page-item active" part="current-page-simple-mode">
                <span class="page-link" aria-current="page">${currentPage}</span>
              </li>
              <li class="page-item" aria-hidden="true"><span class="page-link">/</span></li>
              <li class="page-item" part="total-pages-simple-mode">
                <span class="page-link">${totalPages}</span>
              </li>
            `, () => html `
              ${when(showFirstPage, () => html `
                  <li class="page-item more">
                    <a class="page-link" href="#" @click="${(e) => this.handlePageClick(e, 1)}">1</a>
                  </li>
                `)}
              ${when(showFirstEllipsis, () => html `
                  <li class="page-item more">
                    <span class="page-link">...</span>
                  </li>
                `)}
              <slot @slotchange="${this.handleSlotChange}"></slot>
              ${when(showLastEllipsis, () => html `
                  <li class="page-item more">
                    <span class="page-link">...</span>
                  </li>
                `)}
              ${when(showLastPage, () => html `
                  <li class="page-item more">
                    <a class="page-link" href="#" @click="${(e) => this.handlePageClick(e, totalPages)}">
                      ${totalPages}
                    </a>
                  </li>
                `)}
            `)}

          <li class="pagination-next-wrapper page-item" @click="${this.handleNextClick}">
            <slot name="next" @slotchange="${this.handleNextSlotChange}"></slot>
          </li>
        </ul>

        <slot name="page-changer"></slot>
        <slot name="jump-to-page"></slot>
        <slot name="total" @slotchange="${this.handleTotalSlotChange}"></slot>
      </nav>
    `;
    }
    handlePageClick(e, page) {
        e.preventDefault();
        this.emitPageChange(page);
    }
};
ItPagination.styles = styles;
ItPagination.shadowRootOptions = { ...BaseComponent.shadowRootOptions, delegatesFocus: true };
__decorate([
    queryAssignedElements({ selector: 'it-pagination-item' }),
    __metadata("design:type", Array)
], ItPagination.prototype, "paginationItems", void 0);
__decorate([
    queryAssignedElements({ slot: 'prev' }),
    __metadata("design:type", Array)
], ItPagination.prototype, "prevElements", void 0);
__decorate([
    queryAssignedElements({ slot: 'next' }),
    __metadata("design:type", Array)
], ItPagination.prototype, "nextElements", void 0);
__decorate([
    queryAssignedElements({ slot: 'total' }),
    __metadata("design:type", Array)
], ItPagination.prototype, "totalElements", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", Object)
], ItPagination.prototype, "value", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", Object)
], ItPagination.prototype, "total", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", String)
], ItPagination.prototype, "align", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItPagination.prototype, "disableResponsive", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'simple-mode' }),
    __metadata("design:type", Object)
], ItPagination.prototype, "simpleMode", void 0);
__decorate([
    property({ type: Number, reflect: true, attribute: 'visible-pages' }),
    __metadata("design:type", Object)
], ItPagination.prototype, "visiblePages", void 0);
__decorate([
    property({ type: String, attribute: 'it-aria-label', reflect: true }),
    __metadata("design:type", Object)
], ItPagination.prototype, "itAriaLabel", void 0);
ItPagination = __decorate([
    customElement('it-pagination')
], ItPagination);

export { ItPagination };
//# sourceMappingURL=it-pagination.js.map
